// extracted by mini-css-extract-plugin
export var table = "_vt-0";